import React from 'react';

import ActionsModal from './ActionsModal/ActionsModal';

type ConfirmDeleteModalProps = {
  isOpen?: boolean;
  onDelete(): void;
  onBack(): void;
};

const ConfirmDeleteModal = ({ isOpen, onDelete, onBack }: ConfirmDeleteModalProps) => (
  <ActionsModal
    isOpen={isOpen}
    heading="campaigns.form.confirm-delete.heading"
    description="campaigns.form.confirm-delete.description"
    actions={[
      {
        label: 'campaigns.form.confirm-delete.action-yes',
        size: 'small',
        variant: 'secondaryNegative',
        onClick: onDelete,
      },
      {
        label: 'campaigns.form.confirm-delete.action-no',
        size: 'small',
        variant: 'secondary',
        onClick: onBack,
      },
    ]}
    onClose={onBack}
  />
);

export default ConfirmDeleteModal;
